<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/pages/login.png"
                  alt="login"
                  class="mx-auto"
                />
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="px-8 pt-8 login-tabs-container login-area">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">ورود به سامانه</h4>
                    <p>
                      {{
                        phone
                          ? "کد 4 رقمی را وارد کنید"
                          : "جهت ورود به سامانه، شماره همراه خود را وارد کنید"
                      }}
                    </p>
                  </div>

                  <user-code
                    @edit-phone="phone = ''"
                    :phone="phone"
                    v-if="phone"
                  ></user-code>
                  <phone v-else @send-phone="setPhone($event)"></phone>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Phone from "./Phone.vue";
import Code from "./Code.vue";
import Cookies from "js-cookie";

export default {
  components: {
    Phone,
    UserCode: Code,
  },
  data() {
    return {
      phone: false,
    };
  },
  mounted() {
    const token = Cookies.get("employee_access_token");
    console.log(token);
  },
  methods: {
    setPhone(phone) {
      this.phone = phone;
    },
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.login-area {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
